<h2 class="text-center">{{ label }}</h2>
<div *ngIf="error; else showNovelist">
  <div class="error">
    <em class="fa fa-book"></em>
    <p class="text-center error-message">{{ error }}</p>
  </div>
</div>
<ng-template #showNovelist>
  <div [innerHtml]="novelist | safeHtml"></div>
</ng-template>
<div *ngIf="loader">
  <mat-spinner class="spinner" [diameter]="100" strokeWidth="5" color="accent"></mat-spinner>
</div>
